import styled from '@emotion/styled';

export const Body = styled.div`
  display: grid;
  row-gap: 12px;
  align-content: space-between;
  padding: 8px 0;
`;
